import { useTrackCheckoutPageStep } from './useTrackCheckoutPageStep'
import { useTrackPaymentMethod } from './useTrackPaymentMethod'
import { useTrackShippingMethod } from './useTrackShippingMethod'

export const TrackCheckoutSteps = (): null => {
    useTrackCheckoutPageStep()
    useTrackShippingMethod()
    useTrackPaymentMethod()
    return null
}
